import React, { useRef, useState } from "react";
import { Modal } from "@/components/Layout";
import api, { API } from "@/lib/api";

/** Import din Excel pentru ecranele Stat de Funcții Didactic: „Import Excel” + „↓ Template Excel” + raportul importului
 *  (create / actualizate / avertismente / erori pe rânduri). `url` primește fișierul (POST), `templateUrl` e linkul către template. */
export default function SfdImport({ url, params, templateUrl, onDone, onError, testid = "sfd-import", disabled = false, children }) {
  const fileRef = useRef(null);
  const [report, setReport] = useState(null);
  const run = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { const r = await api.post(url, fd, { params }); setReport(r.data); onDone && onDone(r.data); }
    catch (e) { onError && onError(e?.response?.data?.detail || "Eroare la import"); }
    if (fileRef.current) fileRef.current.value = "";
  };
  return (
    <>
      <button className="btn btn-secondary" disabled={disabled} onClick={() => fileRef.current && fileRef.current.click()} data-testid={`${testid}-btn`}>Import Excel</button>
      <input ref={fileRef} type="file" accept=".xlsx" style={{ display: "none" }} onChange={e => run(e.target.files[0])} data-testid={`${testid}-file`} />
      <a className="btn btn-secondary" href={`${API}${templateUrl}`} data-testid={`${testid}-template`}>↓ Template Excel</a>
      {children}
      {report && (
        <Modal title="Raport import" onClose={() => setReport(null)} width={640}>
          <div data-testid={`${testid}-report`} style={{ fontSize: 14 }}>Create: <b>{report.created}</b> · Actualizate: <b>{report.updated}</b> · Erori: <b>{report.errors.length}</b>{report.warnings ? <> · Avertismente: <b>{report.warnings.length}</b></> : null}</div>
          {report.errors.length > 0 && <ul style={{ marginTop: 10, fontSize: 13, color: "#991B1B", maxHeight: 240, overflow: "auto" }}>{report.errors.map((e, i) => <li key={i}>Rândul {e.row}: {e.error}</li>)}</ul>}
          {report.warnings && report.warnings.length > 0 && <ul style={{ marginTop: 10, fontSize: 13, color: "#92400E", maxHeight: 160, overflow: "auto" }}>{report.warnings.map((w, i) => <li key={i}>Rândul {w.row}: {w.warning}</li>)}</ul>}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}><button className="btn btn-primary" onClick={() => setReport(null)}>Închide</button></div>
        </Modal>)}
    </>
  );
}
